import { apiRequest } from '../http/httpClient';

export const cartApi = {
  /** Crea un carrito en Shopify con estas líneas y devuelve { checkoutUrl, ... }: el pago lo hace Shopify. */
  createCheckout(lines) {
    return apiRequest('/api/cart', {
      method: 'POST',
      body: { lines: lines.map((line) => ({ productHandle: line.productId, quantity: line.quantity })) },
    });
  },
};
